<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <el-form :model="goodsForm" :rules="rules" ref="goodsForm" label-width="120px">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="商品类型" prop="name">
                            <el-radio-group v-model="goodsForm.type" size="small">
                                <el-radio :label="1" border>兑换</el-radio>
                                <el-radio :label="2" border>预定</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
<!--                    <el-col :span="12">-->
<!--                        <el-form-item label="社区：" prop="project" v-if="user.power === 3">-->
<!--                            <el-select v-model="goodsForm.project" placeholder="请选择社区" style="width: 100%;">-->
<!--                                <el-option-->
<!--                                    v-for="item in projectList"-->
<!--                                    :key="item.id"-->
<!--                                    :label="item.name"-->
<!--                                    :value="item.id">-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                    <el-col :span="12">
                        <el-form-item label="商品名称" prop="name">
                            <el-input v-model="goodsForm.name" placeholder="请输入商品名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="商品价格" prop="price">
                            <el-input type="number" v-model="goodsForm.price" placeholder="请输入商品价格"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="goodsForm.type === 1">
                        <el-form-item label="商品库存" prop="num">
                          <div class="flex align-center">
                              <el-input type="number" v-model="goodsForm.num" placeholder="请输入商品库存" :readonly="isRead"></el-input>
                              <template v-if="isRead">
                                  <el-popover
                                      placement="bottom"
                                      class="margin-left-sm"
                                      trigger="manual"
                                      v-model="addvisible">
                                      <div class="flex align-center">
                                          <el-input type="number" v-model="num" placeholder="请输入添加数量"></el-input>
                                          <el-button class="margin-left-xs"  type="primary" size="mini" @click="changeNum(1)">确定</el-button>
                                      </div>
                                      <el-button slot="reference"  type="primary" size="mini" @click="addvisible = !addvisible;delvisible =false">添加</el-button>
                                  </el-popover>
                                  <el-popover
                                      placement="bottom"
                                      class="margin-left-sm"
                                      trigger="manual"
                                      v-model="delvisible">
                                      <div class="flex align-center">
                                          <el-input type="number" v-model="num" placeholder="请输入减少数量"></el-input>
                                          <el-button class="margin-left-xs"  type="primary" size="mini" @click="changeNum(2)">确定</el-button>
                                      </div>
                                      <el-button slot="reference"  type="primary" size="mini"  @click="delvisible = !delvisible;addvisible = false">减少</el-button>
                                  </el-popover>
                              </template>
                          </div>
                        </el-form-item>
                    </el-col>
<!--                    <el-col :span="12">-->
<!--                        <el-form-item :label="'个人'+(goodsForm.type === 1?'兑换':'预定')+'上限'" prop="exchange_num">-->
<!--                            <el-input type="number" v-model="goodsForm.exchange_num" :placeholder="'请输入个人'+goodsForm.type === 1?'兑换':'预定'+'上限'"></el-input>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
<!--                    <el-col :span="12">-->
<!--                        <el-form-item :label="goodsForm.type === 1?'兑换时间':'预定时间'" prop="exchange_time">-->
<!--                            <el-date-picker-->
<!--                                style="width: 100%"-->
<!--                                v-model="goodsForm.exchange_time"-->
<!--                                type="datetimerange"-->
<!--                                range-separator="至"-->
<!--                                start-placeholder="开始日期"-->
<!--                                end-placeholder="结束日期">-->
<!--                            </el-date-picker>-->
<!--                        </el-form-item>-->
<!--                    </el-col>-->
                </el-row>


                <el-form-item label="商品照片" prop="images">
                    <el-upload
                        ref="upload"
                        :action="upUrl"
                        :name="'file'"
                        :data="QiniuData"
                        :before-upload="beforeAvatarUpload"
                        :limit="limit"
                        list-type="picture-card"
                        :file-list="goodsForm.images"
                        :on-success="handleSuccess"
                        :on-remove="handleRemove"
                    >
                        <i class="el-icon-plus"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="商品介绍" prop="content">

                    <VueUditorWrap v-model="goodsForm.content" :config="myConfig"></VueUditorWrap>
                </el-form-item>

                <el-form-item class="flex align-center justify-around" label-width="0">
                    <el-button class="padding-lr-xl" type="primary" @click="submitForm('goodsForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig, getQNFileKey, zhDate} from "@/utils/utils";
import {FILE_UPLOAD_HOST_QN} from "@/config";
import {addProduct, productDetail, setProductNum} from "@/api/weilao";
import {getQiniuUrl, getXiangMuList} from "@/api/common";
import {getQNToken} from "@/utils/CryptoJS";

export default {
    name: "shopping-add",
    data() {
        return {
            myConfig: bdEditConfig(),
            upUrl: FILE_UPLOAD_HOST_QN,
            projectList: [],
            goodsForm: {
                type: 1,
                project: '',
                name: '',
                price: '',
                num: '',
                exchange_num: '',
                exchange_time: [],
                images: [],
                content: '',
            },
            rules: {
                project: [{required: true, message: '请选择社区', trigger: 'blur'}],
                name: [{required: true, message: '请输入商品名称', trigger: 'blur'}],
                price: [{required: true, message: '请输入商品价格', trigger: 'blur'}],
                num: [{required: true, message: '请输入商品库存', trigger: 'blur'}],
                exchange_num: [{required: true, message: '请输入个人兑换上限', trigger: 'blur'}],
                exchange_time: [{required: true, message: '请选择兑换时间', trigger: 'change'}],
                images: [{required: true, message: '请上传商品照片', trigger: 'change'}],
                content: [{required: true, message: '请输入商品介绍', trigger: 'blur'}],
            },
            limit: 9,
            num:'',
            addvisible:false,
            delvisible:false,

            QiniuData: {
                fname: '', //  文件名
                key: '', //文件名字处理
                token: getQNToken() //七牛云token
            },
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        isRead() {
            return this.$route.params.id != 0
        },
        fileData() {
            return {
                token: this.user.token,
                addWatermark: 0
            };
        },
        goodsImg() {
            let _arr = []
            this.goodsForm.images.map(item => {
                _arr.push(item.path)
            })
            return JSON.stringify(_arr)
        }
    },
    components: {VueUditorWrap},
    created() {
        this.$emit("setIndex", '/home/shopping', "双暖为老 / 商品编辑", true);
        if (Number(this.$route.params.id)) this.getDetail()
        this.getXiangMuList()
    },
    methods: {
        async getXiangMuList() {
            let _data = await getXiangMuList()
            this.projectList = _data.data
            if (this.user.power !== 3) {
                this.goodsForm.project = _data.data[0].id
            }
        },
        //  获取商品详情
        async getDetail() {
            let _data = await productDetail(this.$route.params.id)
            this.goodsForm.type = _data.data.type ? Number(_data.data.type) : 1
            this.goodsForm.project = _data.data.xiangmu_id
            this.goodsForm.name = _data.data.name
            this.goodsForm.price = _data.data.price
            this.goodsForm.num = _data.data.num
            this.goodsForm.exchange_num = _data.data.exchange_num
            this.goodsForm.exchange_time = [new Date(_data.data.exchange_start_time), new Date(_data.data.exchange_end_time)]
            this.goodsForm.content = _data.data.content
            let _arr = JSON.parse(_data.data.images)
            _arr.map(item => {
                this.goodsForm.images.push({
                    name: 'goods',
                    url: item,
                    path: item
                })
            })

        },
        async changeNum(type) {
            if (!this.num) return this.$message.error('请输入数量')
            let _data = await setProductNum(this.$route.params.id,type,this.num)
            if (_data.status === 200) {
                this.num = ''
                this.addvisible = false
                this.delvisible = false
                this.$message.success('操作成功')
                this.getDetail()
            }
        },
        //  提交保存商品
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await addProduct(
                this.goodsForm.type,
                this.goodsForm.project,
                this.goodsForm.name,
                this.goodsForm.price,
                this.goodsForm.num,
                this.goodsForm.exchange_num,
                zhDate(new Date(this.goodsForm.exchange_time[0]), 1),
                zhDate(new Date(this.goodsForm.exchange_time[1]), 1),
                this.goodsImg,
                this.goodsForm.content,
                this.$route.params.id ? this.$route.params.id : '',
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$refs['upload'].clearFiles()
            this.$router.go(-1)
        },
        //  删除图片
        handleRemove(file, fileList) {
            this.goodsForm.images = fileList
            console.log(this.goodsForm.images)
        },
        //  上传钱判断
        beforeAvatarUpload(file) {
            this.QiniuData.fname = file.name;
            this.QiniuData.key = getQNFileKey(`${new Date().getTime()}${file.name}`)
        },
        //  上传图片
        async handleSuccess(file) {
            let _data = await getQiniuUrl(file.key)
            this.goodsForm.images.push({
                name: 'goods',
                url: _data.data.url,
                path: _data.data.url
            })
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss">

</style>
